import { useState } from 'react'

import { InfoBadge, InfoBadgeTypes, Label } from '@procurify/ui'
import styled from 'styled-components'

import { ConnectedVendorDetailModal } from '@webapp/components/VendorDetail'
import { WithConnectedVendorTooltip } from '@webapp/components/VendorTooltip/WithConnectedVendorTooltip'
import { useFormatVendor, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ColumnTypeData } from '../../types/DataTable.types'

const VendorCellLinkStyled = styled.a`
  display: inline-block;
  cursor: pointer;
`

export const VendorCell = ({
  vendor,
  otherVendorName,
  plainText,
  isPending,
}: ColumnTypeData['VENDOR']) => {
  const intl = useProcurifyIntl()
  const formatVendor = useFormatVendor()
  const [showModal, setShowModal] = useState(false)
  const onVendorCellClick = () => {
    setShowModal(true)
  }

  const onVendorModalDismiss = () => {
    setShowModal(false)
  }

  const vendorName = formatVendor(vendor, otherVendorName)

  if (plainText) {
    return <>{vendorName}</>
  }

  return isPending ? (
    <>
      <Label>{vendorName}</Label>
      <InfoBadge
        type={InfoBadgeTypes.LOW_PRIORITY}
        text={intl.formatMessage(messages.vendorRequestPendingStatusLabel)}
      />
    </>
  ) : (
    <>
      <WithConnectedVendorTooltip vendorId={vendor?.id}>
        <VendorCellLinkStyled onClick={() => onVendorCellClick()}>
          <Label>{vendorName}</Label>
        </VendorCellLinkStyled>
      </WithConnectedVendorTooltip>

      <ConnectedVendorDetailModal
        vendorId={vendor?.id}
        open={showModal}
        onDismiss={onVendorModalDismiss}
      />
    </>
  )
}
